export default __webpack_public_path__ + "static/media/deactivate-user.70692b9d.svg";